import type { ChangelogVersion } from './types';

export interface ReleaseVersionGroup {
  minorVersion: string;
  entries: ChangelogVersion[];
  nested: boolean;
}

/**
 * Preserve changelog order while grouping semantic patch releases under
 * their major.minor line (for example 5.2.2, 5.2.1, 5.2.0 under 5.2).
 * Non-semantic headings remain standalone so custom release labels still work.
 */
export function groupVersionsByMinor(
  versions: ChangelogVersion[],
): ReleaseVersionGroup[] {
  const groups: ReleaseVersionGroup[] = [];
  const semanticGroups = new Map<string, ReleaseVersionGroup>();

  for (const entry of versions) {
    const match = entry.version.match(/^(\d+)\.(\d+)\.(\d+)(?:[-+].*)?$/);
    if (!match) {
      groups.push({
        minorVersion: entry.version,
        entries: [entry],
        nested: false,
      });
      continue;
    }

    const minorVersion = `${match[1]}.${match[2]}`;
    let group = semanticGroups.get(minorVersion);
    if (!group) {
      group = { minorVersion, entries: [], nested: true };
      semanticGroups.set(minorVersion, group);
      groups.push(group);
    }
    group.entries.push(entry);
  }

  return groups;
}
